export default "__VITE_ASSET__DUBeNO7O__"